<script lang="ts" setup>
import FooterCopyright from '@Molecules/Footer/FooterCopyright.vue'
import FooterMenu from '@Blocks/Footer/FooterMenu.vue'

defineOptions({
  name: 'AppFooter',
})

</script>

<template>
  <div class="app-footer">
    <div class="app-footer__container">
      <FooterCopyright class="desktop" />
      <FooterMenu />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/AppFooter.scss" />